import { useRoutes } from "react-router-dom";
import NotFound from "../pages/NotFound/NotFound";
import Main from "../pages/Main/Main";
import {
  COMMUNITY_MYPAGE,
  COMMUNITY_PAGE_CODE,
  COMMUNITY_PAGE_CODE_CATEGORY,
  COMMUNITY_PAGE_CODE_IDX
} from "./contant";
import { browserName } from "react-device-detect";
import Profile from "../pages/Profile/Profile";
import NotSupport from "../pages/NotSupport/NotSupport";

const Pageroutes = () => {
  let element = useRoutes([
    {
      path: COMMUNITY_PAGE_CODE,
      element: <Main />,
      children: [
        {
          path: COMMUNITY_PAGE_CODE_CATEGORY,
          element: <Main />,
          children: [{ path: COMMUNITY_PAGE_CODE_IDX, element: <Main /> }]
        }
      ]
    },
    {
      path: COMMUNITY_MYPAGE,
      element: <Profile />,
      children: [
        {
          path: COMMUNITY_PAGE_CODE_CATEGORY,
          element: <Profile />,
          children: [{ path: COMMUNITY_PAGE_CODE_IDX, element: <Profile /> }]
        }
      ]
    },
    {
      path: "*",
      element: <NotFound />
    },
    {
      path: "/notfound",
      element: <NotFound />
    }
  ]);

  if (browserName === "IE") {
    return <NotSupport />;
  }
  return element;
};

export default Pageroutes;
